import { SupportTrip } from "domain/entities/support-trip";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface SupportTripState {
  supportTripToCancel: SupportTrip | null;
  setSupportTripToCancel: (newParameter: Partial<SupportTrip>) => void;
  resetSupportTripToCancel: () => void;
}

const initialSupportTripState: SupportTrip = {
  id: "",
  employee: {
    id: "",
    name: ""
  },
  locationOrigin: "",
  locationDestination: "",
  distanceKm: -1,
  tripValue: -1,
  dateTrip: new Date(),
  status: "",
  rejectionReason: "",
  createdAt: new Date(),
  modifiedAt: new Date(),
  lastModifiedBy: "",
};

export const useSupportTripCancelStore = create<SupportTripState>()(
  devtools(
    (set) => ({
      supportTripToCancel: initialSupportTripState,
      setSupportTripToCancel: (newParameter: SupportTrip) =>
        set((state) => ({
          supportTripToCancel: {
            ...state.supportTripToCancel,
            ...newParameter,
          } as SupportTrip,
        })),
      resetSupportTripToCancel: () =>
        set({ supportTripToCancel: initialSupportTripState }),
    }),
    { name: "ParameterSelected" }
  )
);
